import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'

// 导入语言包信息
import en from '../../i18n/en.json'
import zh from '../../i18n/zh.json'
import zhCN from 'vxe-table-quantdata/lib/locale/lang/zh-CN'
import enUS from 'vxe-table-quantdata/lib/locale/lang/en-US'

// 注册i18n
Vue.use(VueI18n)

// 语言包根据语言环境分类
const messages = {
  en:{
    ...en,
    ...enUS
  },
  zh:{
    ...zh,
    ...zhCN
  }
}

// 通过选项创建 VueI18n 实例并导出
export default new VueI18n({
  locale: Cookies.get('locale') || 'zh', // 从cookie中读取当前语言环境，默认中文简体
  fallbackLocale: 'zh', // 找不到该内容时，使用默认语言的内容
  messages // 设置语言环境对应信息
})



// WEBPACK FOOTER //
// ./src/i18n/index.js